/**
 * Password management routes (server: auth.routes.ts, PasswordService).
 * The forgot-password answer is the same whether the account exists or not.
 */
import { apiClient } from '../client';

export function requestPasswordReset(email: string): Promise<unknown> {
  return apiClient.post('/auth/forgot-password', { email: email.trim().toLowerCase() });
}

export function resetPassword(token: string, password: string): Promise<unknown> {
  return apiClient.post('/auth/reset-password', { token, password });
}

export function changePassword(currentPassword: string, newPassword: string): Promise<unknown> {
  return apiClient.post('/auth/change-password', { currentPassword, newPassword });
}
